module.exports = __webpack_public_path__ + "img/loadingbg.c0a523c2.jpg";